import { useEffect, useState } from 'react';

const useRichTextADAFixer = (content: string, deep = 1, isOnlyPcTextWhite = true, isTextWhite = false) => {
  const [modifiedHtml, setModifiedHtml] = useState<string>(content);

  useEffect(() => {
    const addAriaLabelsToLinks = (htmlString: string): string => {
      // Create a new DOM parser
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      // Select all <a> tags in the parsed document
      const links = doc.querySelectorAll('a');

      links.forEach(link => {
        const href = link.getAttribute('href');
        let ariaLabel = '';

        if (link.innerText) {
          ariaLabel = link.innerText;
        }

        if (href) {
          // Remove trailing slash, get the last part of the URL, and replace hyphens with spaces
          const lastPart = href
            .replace(/\/$/, '') // Remove trailing slash
            .split('/') // Split the URL by slashes
            .slice(-deep) // Gets last "deep" elements
            .join(' ') // Joins last elements in a string
            ?.replace(/-/g, ' '); // Replace hyphens with spaces

          // Set the aria-label with the calculated last part, if available
          if (lastPart) {
            ariaLabel = `${ariaLabel} ${lastPart}`;
          }
        }

        if (ariaLabel) {
          link.setAttribute('aria-label', ariaLabel.trim());
        }
        if (isTextWhite) {
          const className = isOnlyPcTextWhite ? 'bs-tablet:tw-text-color-white' : 'tw-text-color-white';
          link.setAttribute('class', className);
        }
      });

      // Return the modified HTML string
      return doc.body.innerHTML;
    };

    const updatedHtml = addAriaLabelsToLinks(content);
    setModifiedHtml(updatedHtml);
  }, [content, deep, isOnlyPcTextWhite, isTextWhite]);

  return modifiedHtml;
};

export default useRichTextADAFixer;
